import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get the current list of supported plugins
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetPlugins = packet => {
  return {
    type: 'REQUEST_GET_PLUGINS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetPluginsSuccess = data => ({
  type: 'RECEIVE_GET_PLUGINS_SUCCESS',
  data
})

export const receiveGetPluginsFail = data => ({
  type: 'RECEIVE_GET_PLUGINS_FAIL',
  data
})

export const tryToGetPlugins = packet => (dispatch, getState) => {

  dispatch(requestGetPlugins(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/intel/plugins', {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetPluginsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetPluginsFail({errors:e, lastSubmit: packet}));
    })
}
